module.exports = {
	"base": {
		"welcome": "Mulligans'a hoş geldin, %{name}!",
		"user": "Kullanıcı Bilgisi",
		"devices": "Cihazlar",
		"refunds": "İadeler",
		"resources": "Kaynaklar",
		"transactions": "Siparişler ve İadeler",
		"email": "E-posta",
		"password": "Parola",
		"save": "Kaydet",
		"sign-out": "Oturumu Kapat",
		"cancel": "İptal",
		"close": "Kapat",
		"learn-more": "Daha fazla bilgi al",
		"required": "Gerekli",
		"support": "Destek",
		"bookshelf": "Bookshelf",
		"launch": "Başlat",
		"download": "İndir",
		"details": "Ayrıntılar",
		"cannot-be-blank": "%{field} boş bırakılamaz.",
		"saving": "Kaydediliyor...",
		"done": "Bitti",
		"failed": "Başarısız",
		"copy": "Kopyala"
	},
	"signin": {
		"login-failure": "E-postanız veya parolanız yanlış",
		"welcome-large": "%{brand} Hesap Merkezine <span class='inner'>hoş geldiniz</span>",
		"welcome-small": "<span class='inner'>Hesap Merkezi</span>",
		"signin-button": "Oturum Aç",
		"forgot-password": "Parolanızı mı Unuttunuz",
		"new-to-vst": "%{brand}'de yeni misiniz?",
		"create-account": "Bir Hesap Oluştur",
		"signing-in": "Giriş yapılıyor...",
		"signin-failed": "Giriş başarısız"
	},
	"transactions": {
		"price": "Ücret",
		"excluded": "(Vergi hariç)",
		"quantity": "Miktar",
		"confirmation#": "Teyit no",
		"payment": "Ödeme",
		"purchased": "Satın alınan",
		"purchase-details": "Satın Alma Detayları",
		"subtotal": "Ara Toplam",
		"total": "Toplam",
		"tax": "Vergi",
		"loading": "Selam çok para harcayan, hareketlerini yüklüyoruz...",
		"no-purchases": "Hiç satın alman yok.",
		"seller-vat": "Satıcı KDV'si",
		"total-vat": "Ödenen %{vat} Toplam",
		"portion": "%{subTax} Vergi %{rate}%",
		"vat-disclosure": "Fiyata %{vat} dahildir",
		"purchases": "Alımlar",
		"refunded-items": "Parası İade Edilen Kalemler",
		"book-title": "Kitap İsmi",
		"refund-details": "İade Detayları",
		"print-receipt": "Makbuzu Yazdır",
		"request-refund": "Para İadesi İste",
		"expired": "Sona Erdi",
		"expires-in": "Bitiş tarihi %{date}",
		"details-refund": "Ayrıntılar ve Para İadesi",
		"modal": {
			"cant-refund-title": "İade Mevcut Değil",
			"cant-refund": "Kitabınız aşağıdaki nedenlerden biri veya daha fazlası nedeniyle iade edilemez.",
			"cant-refund-1": "Kitabınızın çoğu görüntülenmiş.",
			"cant-refund-2": "Satın alma tarihinin üzerinden 14 günden fazla zaman geçmiş.",
			"cant-refund-3": "Çevrimiçi kaynak kodunuz ifşa olmuş.",
			"cant-refund-4": "Kitabınız önceden iade edilmiş.",
			"cant-refund-5": "Tüm kodlar parası ödenerek alındı ve/veya iade edildi.",
			"cant-refund-6": "Satın alma tarihinin üzerinden 30 günden fazla zaman geçmiş.",
			"cant-refund-support": "Hala %{brand}''nin iade politikasından emin değilseniz, <a href='%{support_url}' target='_blank'>destek ile</a>iletişime geçin."
		},
		"license": {
			"perpetual": "Çevrimiçi erişimin süresi geçmez",
			"days": "%{days} Gün Erişim"
		}
	},
	"devices": {
		"description": "%{brand} sizin <span>%{desktop} bilgisayarlarda</span> ve <span>%{mobile} mobil/tablet cihazlarda</span> her zaman etkinleştirmenize olanak sağlar.",
		"loading": "Hey, cihazlarını alıyoruz :)",
		"no-active": "Aktif cihazın yok.",
		"deactivate": "Devre dışı bırak"
	},
	"user": {
		"personal-information": "Kişisel Bilgiler",
		"security-information": "Güvenlik Bilgileri",
		"notifications": "Bildirimler",
		"first-name": "Ad",
		"last-name": "Soyadi",
		"change-password-title": "Şifre Değiştir",
		"current-password": "Şu Anki Şifre",
		"new-password": "Yeni Şifre",
		"security-password": "Parola",
		"confirm-new-password": "Yeni Şifreyi Onayla",
		"security-question": "Güvenlik Sorusu",
		"security-info-change": "Değişim",
		"question": "Soru",
		"answer": "Yanıt",
		"notifications-text": "Bana ara sıra hesap aktivitem, ürün güncellemeleri ve özel teklifler hakkında e-posta yolla.",
		"loading": "Spot kullanıcı bilgilerinizi alıyor, bir saniye 🐶",
		"change-password-text": "Parola en az 8 karakterden, bir büyük harften, bir küçük harften ve spesifik bir karakterden oluşmalıdır.",
		"email-locked": "E-posta Kilitli",
		"email-locked-description": "E-posta adresini değiştirme iznin yok.",
		"email-locked-more": "Lütfen sistem yöneticinle temasa geç.",
		"security-question6": "En sevdiğin spor nedir?",
		"security-question7": "En sevdiğin dondurma hangisidir?",
		"security-question8": "En sevdiğin evcil hayvanın adı nedir?",
		"security-question9": "Küçükken büyüyünce ne olmak isterdin?",
		"security-question10": "En sevdiğin öğretmeninin soyadı neydi?",
		"new-password-failure": "Parola gereklilikleri karşılamıyor",
		"confirm-password-failure": "Parolalar eşleşmiyor",
		"new-password-tooltip": "Parolan en az 8 karakter olmalı, büyük harf, küçük harf ve özel karakter içermelidir.",
		"enter-valid-email": "Lütfen geçerli bir e-posta girin.",
		"password-cannot-be-same": "Parola öncekiyle aynı olamaz",
		"incorrect-password": "Hatalı Parola",
		"complete-account": "Görünüşe göre <a href='%{href}'>hesabınızı tamamlamanız</a> gerekiyor.",
		"completing-allows": "Hesabınızı tamamlamanız, mobil uygulamalarımızdan kitapları çevrimdışı okumanızı ve arkadaşlarla notları ve vurgulamaları paylaşmanızı sağlar.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Yardımcılar",
		"access-codes": "Erişim Kodları",
		"print-on-demand": "İstendiği Anda Yazdırma",
		"check-pod": "Kitapların için yayıncı yazdırma seçeneklerine bak.",
		"check-now": "Şimdi kontrol et",
		"loading": "Sıkı tutunun, kaynaklarınızı güncelliyoruz!",
		"in": "içinde",
		"access-code-intro": "Erişim kodu erişim kursu içeriğine çevrimiçi erişmek için kullandığınız paroladır. Bir madde için kodu kullanırsanız, bunu geri alamazsınız. Erişim kodlarını nasıl kullanacağınız hakkında daha fazla talimat için Destek bölümünü <a href='%{support_url}' target='_blank'>ziyaret edin</a>.",
		"expires": "Sona Erme Tarihi",
		"expiration-message": "Erişim kodunuzu kullanmanız için talimatlar içerir.",
		"copy-fail": "Kopyalama başarısız. Lütfen kodu seçin ve manüel olarak kopyalayın.",
		"launch-site": "Başlatma Merkezi",
		"launch-book": "Kitabı Başlat",
		"reveal-code": "Kodu Ver",
		"no-resources": "Herhangi bir kaynağa sahip değilsiniz.",
		"no-access-codes": "Herhangi bir erişim koduna sahip değilsiniz.",
		"no-ancillaries": "Bu başlık için yardımcı yok",
		"name": "Ad",
		"type": "Tür",
		"size": "Boyut",
		"download-all": "Tümünü İndir",
		"back": "Kaynaklara geri git"
	},
	"refunds": {
		"states": {
			"refunded": "İade edilmiş",
			"unavailable": "İade Mevcut Değil"
		},
		"reasons": {
			"dropped": "Kursu bıraktım",
			"wrong": "Bu kursum için doğru kitap değildi",
			"print": "Bunun yerine yazılı baskısını almaya karar verdim",
			"missing": "Kitap kursum için ihtiyacım olan her şeyi içermiyor (örn, bir CD, internet erişimi, videolar)",
			"other": "Diğer"
		},
		"bulk": {
			"policy": "Aşağıdaki &quot;İadeyi Tamamla&quot; butonuna tıklayarak, %{brand}'nın <a href='%{policy_url}' target='_blank'>iade politikasını kabul ettiğimi onaylıyorum</a>.",
			"complete": "İadeyi Tamamla",
			"view-details": "İade Detaylarını Görüntüle",
			"success": "Para iadesi talebiniz gönderildi. Lütfen işlenmesi için 48 saat bekleyin.",
			"failure": "Hey - bir şeyler ters gitti! Malesef iadeniz işleme alınmadı.",
			"retry": "Yeniden Deneyin",
			"support": "Destek Ekibiyle Görüş",
			"available-codes": "Uygun Kodlar",
			"codes-selected": "Seçilen Kodlar",
			"download": "Kodları İndir",
			"partially-refunded": "Kısmen İade Edilen",
			"pick-one": "Bir iade yapmak için en az bir kod seçmeniz gerekmektedir."
		},
		"refund": "İade",
		"all": "Tümü İade Edilsin Mi?",
		"missing-reason": "Devam etmek için bir neden seçmelisiniz",
		"missing-elaboration": "Lütfen detaylandırın",
		"policy": "Aşağıdaki “İade Talebini Tamamla” düşmesine basarak, bu %{brand} eTextbook'u tekrar satın alırsam, aynı eTextbook için daha sonra iade talebi için hak sahibi olmayacağımı anlarım. Tam iade politikasını görüntüle.",
		"refunded": "İade edildi",
		"sorry": "Satın alımdan memnun kalmadığınız için üzgünüz.",
		"error": "Bir şeyler ters gitti",
		"error-explain": "İadenizi işleme koyamadık. Lütfen yeniden deneyin.",
		"why": "Bize neden olduğunu söyleyin.",
		"no-refunds": "İade edilen ögeniz yok.",
		"select-codes": "İade edilecek kodu/kodları seçin:",
		"number": "Kaç tane?",
		"back": "İadelere geri git"
	},
	"purchases": {
		"back": "Satın almalara geri git"
	},
	"global-bar": {
		"account": "Hesap Ayarları"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/tr.json
 ** module id = 1025
 ** module chunks = 0
 **/